import React, { Component } from 'react'
import PropTypes from 'prop-types'
import GaugeChart from '../../../../../components/ui/charts/recharts/GaugeChart'
import ResultCaret, { caretOrientations } from './components/ResultCaret'

export default class ResultGauge extends Component {
  static propTypes = {
    textBottom: PropTypes.bool,
    onClick: PropTypes.any.isRequired,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    gaugeFieldData: PropTypes.any.isRequired,
    chartHeight: PropTypes.any,
    active: PropTypes.bool,
    isMobile: PropTypes.bool.isRequired,
  }

  static defaultProps = {
    textBottom: false,
    content: 'This is placeholder text',
    chartHeight: 200,
    active: false,
  }

  render() {
    const {
      textBottom,
      onClick,
      content,
      gaugeFieldData,
      chartHeight,
      active,
      isMobile,
    } = this.props

    return (
      <div
        className={`row m-0 view-div ${active ? 'shadow' : ''}`}
        onClick={onClick}
        style={{
          backgroundColor: active ? '#EFF5FC' : '',
        }}
      >
        <div style={{ height: chartHeight, width: textBottom ? '100%' : '50%' }}>
          <GaugeChart chartData={gaugeFieldData} textBottom={textBottom} />
        </div>
        <div
          style={{
            width: textBottom ? '100%' : '50%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            paddingLeft: textBottom ? 0 : 10,
          }}
        >
          {content}
        </div>
        {!isMobile && (
          <div style={{ width: '100%', marginTop: textBottom ? 0 : -40 }}>
            <ResultCaret active={active} activeOrientation={caretOrientations.right} />
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/ResultGauge.js